import AuthorizationStore from '../../common_components/authorization/AuthorizationStore';
import { STARTUP_ROLES } from '../../common_components/authorization/constants';

export default class Authorization extends AuthorizationStore {
  constructor(rootStore, currentUserPermission) {
    super(rootStore, currentUserPermission);
  }

  // get authShow() {
  //     return this.authorization(SHOW_BOARD_ALLOWED_ROLES)
  // }

  canEditNote(note) {
    return (
      this.canUpdate // &&
      // (this._isNoteCreator(note) ||
      //   (!this._isNoteBelongToCeoOrCofounder(note) &&
      //     this.authorizationApi([
      //       STARTUP_ROLES.CEO,
      //       STARTUP_ROLES.CO_FOUNDER,
      //       STARTUP_ROLES.LEADER
      //     ])(this.rootStore))
      //     )
    );
  }

  canDeleteNote(note) {
    return (
      this.canUpdate
      && (this._isNoteCreator(note)
        || this.authorizationApi([STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER])(
          this.rootStore,
        ))
    );
  }

  canEditNotePriority(note) {
    return this.canEditNote(note);
  }

  canEditNoteComplexity(note) {
    return this.canEditNote(note);
  }

  canChangeNotePriority(note, priority) {
    return (
      this.canUpdate
      && (this._isNoteCreator(note)
        // PRIORITIES_TO_INTEGER[priority] > PRIORITIES_TO_INTEGER[note.priority] &&
        || this.canEditNotePriority(note))
    );
  }

  canChangeNoteComplexity(note, complexity) {
    return (
      this.canUpdate
      && (this._isNoteCreator(note)
        // PRIORITIES_TO_INTEGER[priority] > PRIORITIES_TO_INTEGER[note.priority] &&
        || this.canEditNoteComplexity(note))
    );
  }

  _isNoteCreator(note) {
    return note && note.creator && note.creator.id === this.rootStore.user.id;
  }

  _isNoteBelongToCeoOrCofounder(note) {
    return (
      note
      && note.creator
      && (this.rootStore.ceo.id === note.creator.id
        || this.rootStore.coFounders.find(cf => cf.id === note.creator.id))
    );
  }

  _isCommentCreator(comment) {
    return (
      comment
      && comment.creator
      && comment.creator.id === this.rootStore.user.id
    );
  }

  canEditComment(comment) {
    return this._isCommentCreator(comment);
  }

  _isAttachmentCreator(attachment) {
    return (
      attachment
      && attachment.creator
      && attachment.creator.id === this.rootStore.user.id
    );
  }

  canEditAttachment(attachment) {
    return this.canUpdate && this._isAttachmentCreator(attachment);
  }

  canCreateTodoListItem(note) {
    return this.canUpdate;
    // return this.canEditNote(note)
  }

  canCreateAttachment(note) {
    return this.canUpdate;
    // return this.canEditNote(note)
  }

  canEditTodo(note) {
    return this.canUpdate;
    // return this.canEditNote(note)
  }

  canDeleteTodoList(note) {
    return (
      this.canUpdate
      && (this.authorizationApi([STARTUP_ROLES.CEO])(this.rootStore)
        || this._isNoteCreator(note))
    );
  }

  get canSaveTodoList() {
    if (this._canSaveTodoList === undefined) {
      this._canSaveTodoList = this.canUpdate
        && this.authorizationApi([
          STARTUP_ROLES.CEO,
          STARTUP_ROLES.STAFF,
          STARTUP_ROLES.CO_FOUNDER,
          STARTUP_ROLES.BOARD_MEMBER,
        ])(this.rootStore);
    }

    return this._canSaveTodoList;
  }

  get canEditLabel() {
    if (this._canEditLabel === undefined) {
      this._canEditLabel = this.canUpdate
        && this.authorizationApi([
          STARTUP_ROLES.STAFF,
          STARTUP_ROLES.CEO,
          STARTUP_ROLES.CO_FOUNDER,
          STARTUP_ROLES.BOARD_MEMBER,
        ])(this.rootStore);
    }

    return this._canEditLabel;
  }

  get canDeleteLabel() {
    if (this._canDeleteLabel === undefined) {
      this._canDeleteLabel = this.canUpdate
        && this.authorizationApi([
          STARTUP_ROLES.STAFF,
          STARTUP_ROLES.CEO,
          STARTUP_ROLES.CO_FOUNDER,
          STARTUP_ROLES.BOARD_MEMBER,
        ])(this.rootStore);
    }

    return this._canDeleteLabel;
  }

  canToggleLabel(note) {
    return this.canEditNote(note) || this.canEditLabel;
  }

  canEditNoteRelation(note) {
    return this.canEditNote(note);
  }
}
